import JobDetail from "./jobDetail"

export default JobDetail
